'use client';

import * as LabelPrimitive from '@radix-ui/react-label';
import * as React from 'react';
import { cn } from 'src/app/lib/utils/tailwindcss';

export type BaseLabelProps = React.ComponentProps<typeof LabelPrimitive.Root>;

function BaseLabel({ className, ...props }: BaseLabelProps) {
  return (
    <LabelPrimitive.Root data-slot="label" className={cn('text-g-80 text-base leading-5', className)} {...props} />
  );
}

export default BaseLabel;
